import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
	constructor() {
		const domSanitizer = inject(DomSanitizer);
		const matIconRegistry = inject(MatIconRegistry);

		// Register icon sets
		matIconRegistry.addSvgIconSetInNamespace(
			'mat_twotone',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-twotone.svg'),
		);

		matIconRegistry.addSvgIconSetInNamespace(
			'mat_outline',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-outline.svg'),
		);

		matIconRegistry.addSvgIconSetInNamespace(
			'mat_solid',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/material-solid.svg'),
		);

		matIconRegistry.addSvgIconSetInNamespace(
			'feather',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/feather.svg'),
		);

		matIconRegistry.addSvgIconSetInNamespace(
			'hero_outline',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-outline.svg'),
		);

		matIconRegistry.addSvgIconSetInNamespace(
			'hero_solid',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-solid.svg'),
		);

		matIconRegistry.addSvgIconSetInNamespace(
			'hero_mini',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/heroicons-mini.svg'),
		);

		// Register custom icons
		const wineArkNamespace = 'wineark';
		matIconRegistry.addSvgIconInNamespace(
			wineArkNamespace,
			'bottle',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_bottle.svg'),
		);

		matIconRegistry.addSvgIconInNamespace(
			wineArkNamespace,
			'bottles',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_bottles.svg'),
		);

		matIconRegistry.addSvgIconInNamespace(
			wineArkNamespace,
			'search',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_search.svg'),
		);

		matIconRegistry.addSvgIconInNamespace(
			wineArkNamespace,
			'wine-glass',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/custom_wine-glass.svg'),
		);

		matIconRegistry.addSvgIconInNamespace(
			wineArkNamespace,
			'search-no',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/search_no.svg'),
		);

		matIconRegistry.addSvgIconInNamespace(
			wineArkNamespace,
			'half_wine',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/halfWine.svg'),
		);

		matIconRegistry.addSvgIconInNamespace(
			wineArkNamespace,
			'wineBottle',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/bottle.svg'),
		);

		matIconRegistry.addSvgIcon(
			'provenance_banner_small',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/provenance_banner_small.svg'),
		);
		matIconRegistry.addSvgIcon(
			'provenance_banner_large',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/provenance_banner_large.svg'),
		);

		matIconRegistry.addSvgIcon(
			'provenance_icon_only',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/Provenance_icon_only.svg'),
		);

		matIconRegistry.addSvgIcon(
			'aromatic_whites',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/AromaticWhites.svg'),
		);
		matIconRegistry.addSvgIcon(
			'cabernet_blend',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/CabernetBlend.svg'),
		);
		matIconRegistry.addSvgIcon(
			'cabernet_sauvignon',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/CabernetSauvignon.svg'),
		);
		matIconRegistry.addSvgIcon(
			'cabernet_shiraz',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/CabernetShiraz.svg'),
		);
		matIconRegistry.addSvgIcon(
			'champagne',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Champagne.svg'),
		);
		matIconRegistry.addSvgIcon(
			'chardonnay',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Chardonnay.svg'),
		);
		matIconRegistry.addSvgIcon(
			'grenache',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Grenache.svg'),
		);
		matIconRegistry.addSvgIcon(
			'pinot_noir',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/PinotNoir.svg'),
		);
		matIconRegistry.addSvgIcon(
			'riesling',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Riesling.svg'),
		);
		matIconRegistry.addSvgIcon(
			'sangiovese',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Sangiovese.svg'),
		);
		matIconRegistry.addSvgIcon(
			'semillon',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Semillon.svg'),
		);
		matIconRegistry.addSvgIcon(
			'shiraz',
			domSanitizer.bypassSecurityTrustResourceUrl('assets/images/wine-types/Shiraz.svg'),
		);
	}
}
